import http from '@/utils/http'
// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return http.get( '/system/dict/data/type/' + dictType)
  }